import '../../../styles/checkout.pcss';
import { initCheckout } from './init';

initCheckout();
